import React from "react";
import { Stack, Typography } from "@mui/material";
import { connect } from "react-redux";

import { getCustomerData, getCustomerIsVendor } from "../../redux/customerData";
import { FOUNDRIES } from "../../constants/industry";
import {
  HubHookFormInput,
  HubHookFormSelect,
  HubHookFormSwitch,
  HubHookFormTagInput,
  IndustryHookFormSelect,
} from "../../components";
import { getUserLocation } from "../../redux/auth";
import { RANKS } from "../../constants/customers";

const CustomerDetails = ({
  isVendor = false,
  disabled = false,
  details = {},
}) => {
  const foundries = details?.locations?.map((l) => l.id);

  return (
    <Stack gap="15px">
      <Typography variant="boldCaptionMain">Customer Info</Typography>
      <Stack
        direction="row"
        gap="10px"
        alignItems="center"
        justifyContent="center"
      >
        <HubHookFormInput
          name="customerName"
          label="Customer"
          placeholder="IPC Foundry Group"
          defaultValue={details.customer}
          disableHelperText
          disabled={disabled}
          required
        />
        <IndustryHookFormSelect
          name="industry"
          label="Industry"
          placeholder="ex. Oil"
          sx={{ flexGrow: "1" }}
          useDefault={!!details.industry}
          defaultValue={details.industry}
          disabled={disabled}
          disableHelperText
          required
        />
        <HubHookFormSelect
          name="isVendor"
          label="Vendor"
          options={["False", "True"]?.map((label, id) => ({ id, label }))}
          sx={{ flexGrow: "1" }}
          defaultValue={Number(!!isVendor)}
          disabled={disabled}
          disableHelperText
          required
        />
      </Stack>
      <HubHookFormSelect
        name="ranking"
        label="Ranking"
        options={RANKS}
        sx={{ flexGrow: "1" }}
        useDefault={!!details?.ranking}
        defaultValue={details?.ranking || 1}
        disabled={disabled}
        disableHelperText
        required
      />
      <HubHookFormInput
        name="notes"
        label="Notes"
        placeholder="Notes..."
        defaultValue={details?.notes}
        disabled={disabled}
        disableHelperText
        multiline
        rows={5}
      />
      <HubHookFormTagInput
        name="locations"
        label="Foundries"
        options={FOUNDRIES}
        defaultValue={foundries}
        disabled={disabled}
        disableHelperText
        required
      />
      <HubHookFormSwitch
        name="active"
        label="Active Customer"
        labelPlacement="end"
        defaultValue={details.active}
        disabled={disabled}
      />
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  isVendor: getCustomerIsVendor(state),
  details: getCustomerData(state),
  userLocation: getUserLocation(state),
});

export default connect(mapStateToProps)(CustomerDetails);
